import {
    FETCH_CATEGORIES_REQUEST,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_FAILURE,
    FETCH_MICROCONTROLLERS_REQUEST,
    FETCH_MICROCONTROLLERS_SUCCESS,
    FETCH_MICROCONTROLLERS_FAILURE,
    FETCH_FIRMWARE_VERSIONS_REQUEST,
    FETCH_FIRMWARE_VERSIONS_SUCCESS,
    FETCH_FIRMWARE_VERSIONS_FAILURE,
    FETCH_FIRMWARE_CODE_REQUEST,
    FETCH_FIRMWARE_CODE_SUCCESS,
    FETCH_FIRMWARE_CODE_FAILURE,
    ADD_FIRMWARE_VERSION_REQUEST,
    ADD_FIRMWARE_VERSION_SUCCESS,
    ADD_FIRMWARE_VERSION_FAILURE,
    UPDATE_FIRMWARE_VERSION_REQUEST,
    UPDATE_FIRMWARE_VERSION_SUCCESS,
    UPDATE_FIRMWARE_VERSION_FAILURE,
    DELETE_FIRMWARE_VERSION_REQUEST,
    DELETE_FIRMWARE_VERSION_SUCCESS,
    DELETE_FIRMWARE_VERSION_FAILURE,
    DEPLOY_FIRMWARE_REQUEST,
    DEPLOY_FIRMWARE_SUCCESS,
    DEPLOY_FIRMWARE_FAILURE
} from '../actions/FirmwareAction';

const initialState = {
    categories: [],
    microcontrollers: {},
    versions: {},
    currentCode: '',
    loading: false,
    error: null,
    deployStatus: null
};

const firmwareReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CATEGORIES_REQUEST:
        case FETCH_MICROCONTROLLERS_REQUEST:
        case FETCH_FIRMWARE_VERSIONS_REQUEST:
        case FETCH_FIRMWARE_CODE_REQUEST:
        case ADD_FIRMWARE_VERSION_REQUEST:
        case UPDATE_FIRMWARE_VERSION_REQUEST:
        case DELETE_FIRMWARE_VERSION_REQUEST:
        case DEPLOY_FIRMWARE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                loading: false,
                categories: action.payload,
                error: null
            };

        case FETCH_MICROCONTROLLERS_SUCCESS:
            return {
                ...state,
                loading: false,
                microcontrollers: action.payload,
                error: null
            };

        case FETCH_FIRMWARE_VERSIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                versions: {
                    ...state.versions,
                    [action.payload.microcontrollerId]: action.payload.versions
                },
                error: null
            };

        case FETCH_FIRMWARE_CODE_SUCCESS:
            return {
                ...state,
                loading: false,
                currentCode: action.payload,
                error: null
            };

        case ADD_FIRMWARE_VERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case UPDATE_FIRMWARE_VERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case DELETE_FIRMWARE_VERSION_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case DEPLOY_FIRMWARE_SUCCESS:
            return {
                ...state,
                loading: false,
                deployStatus: action.payload,
                error: null
            };

        case FETCH_CATEGORIES_FAILURE:
        case FETCH_MICROCONTROLLERS_FAILURE:
        case FETCH_FIRMWARE_VERSIONS_FAILURE:
        case FETCH_FIRMWARE_CODE_FAILURE:
        case ADD_FIRMWARE_VERSION_FAILURE:
        case UPDATE_FIRMWARE_VERSION_FAILURE:
        case DELETE_FIRMWARE_VERSION_FAILURE:
        case DEPLOY_FIRMWARE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        default:
            return state;
    }
};

export default firmwareReducer;